<div class="login-page-wrapper">
    <h1 class="main-heading">New Password</h1>
    <p class="description-text">Please create a new password for your account. Make sure it's strong and secure.</p>
    
    <form [formGroup]="ChangePasswordForm" (ngSubmit)="onSubmitForm($event)" class="form-container">
        <div class="fields-container">
            <div class="mb-3 password-section">
                <label for="password" class="password-label form-label font-weight-bold">Password</label>
                <div class="password-input-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'" class="password-inpute form-control" id="password"
                        formControlName="Password" placeholder="Enter your Password">
                    <i class="fas password-toggle-icon" 
                       [class.fa-eye]="!showPassword" 
                       [class.fa-eye-slash]="showPassword"
                       (click)="togglePasswordVisibility()"></i>
                </div>
                <div *ngIf="ChangePasswordForm.get('Password')?.invalid && (ChangePasswordForm.get('Password')?.dirty || ChangePasswordForm.get('Password')?.touched)"
                    class="text-danger">
                    <small *ngIf="ChangePasswordForm.get('Password')?.errors?.['required']">Password is required.</small>
                    <small *ngIf="ChangePasswordForm.get('Password')?.errors?.['minlength']">Password must be at least 6
                        characters long.</small>
                    <small *ngIf="ChangePasswordForm.get('Password')?.errors?.['custom']">{{
                        ChangePasswordForm.get('Password')?.errors?.['custom'] }}</small>
                </div>
            </div>
            
            <div class="mb-3 confirm-password-section">
                <label for="ConfirmPassword" class="password-label form-label font-weight-bold">Confirm Password</label>
                <div class="password-input-wrapper">
                    <input [type]="showConfirmPassword ? 'text' : 'password'" class="password-inpute form-control" id="ConfirmPassword"
                        formControlName="ConfirmPassword" placeholder="Enter your Confirm Password">
                    <i class="fas password-toggle-icon" 
                       [class.fa-eye]="!showConfirmPassword" 
                       [class.fa-eye-slash]="showConfirmPassword"
                       (click)="toggleConfirmPasswordVisibility()"></i>
                </div>
                <div *ngIf="ChangePasswordForm.get('ConfirmPassword')?.invalid && (ChangePasswordForm.get('ConfirmPassword')?.dirty || ChangePasswordForm.get('ConfirmPassword')?.touched)"
                    class="text-danger">
                    <small *ngIf="ChangePasswordForm.get('ConfirmPassword')?.errors?.['required']">Confirm Password is
                        required.</small>
                    <small *ngIf="ChangePasswordForm.get('ConfirmPassword')?.errors?.['custom']">{{
                        ChangePasswordForm.get('ConfirmPassword')?.errors?.['custom'] }}</small>
                </div>
            </div>
            
            <div class="submition d-flex justify-content-center">
                <button type="submit" class="submit-btn btn btn-primary">Change Password</button>
            </div>
        </div>
    </form>
</div>